import { SelectComponentsConfig } from 'react-select';

import { NULL_OP } from '../../../../../../constants';
import { ClearIndicator } from '../../../overrideParts/ClearIndicator';
import { Control } from '../../../overrideParts/Control';
import { DropdownIndicator } from '../../../overrideParts/DropdownIndicator';
import { MultiValueContainer } from '../../../overrideParts/MultiValueContainer';
import { MultiValueLabel } from '../../../overrideParts/MultiValueLabel';
import { MultiValueRemove } from '../../../overrideParts/MultiValueRemove';
import { Option } from '../../../overrideParts/Option';
import { ValueContainer } from '../../../overrideParts/ValueContainer';
import {
  ControlledSelectGroup,
  ControlledSelectOption,
} from '../../../types/ControlledSelectOption';

export const getReactSelectComponentsOverrides = <
  IsMulti extends boolean = false,
>(): SelectComponentsConfig<
  ControlledSelectOption,
  IsMulti,
  ControlledSelectGroup
> => ({
  ClearIndicator: ClearIndicator<IsMulti>,
  Control: Control<IsMulti>,
  DropdownIndicator: DropdownIndicator<IsMulti>,
  IndicatorSeparator: NULL_OP,
  MultiValueContainer: MultiValueContainer<IsMulti>,
  MultiValueLabel: MultiValueLabel<IsMulti>,
  MultiValueRemove: MultiValueRemove<IsMulti>,
  Option: Option<IsMulti>,
  ValueContainer: ValueContainer<IsMulti>,
});
